import timeless from './definitions/timeless.json';
import wellness from './definitions/wellness.json';
import claire from './definitions/claire.json';
import heritage from './definitions/heritage.json';
import reverie from './definitions/reverie.json';
import garden from './definitions/garden.json';
import midnight from './definitions/midnight.json';
import rustic from './definitions/rustic.json';
import minimalist from './definitions/minimalist.json';
import tropical from './definitions/tropical.json';
import vintage from './definitions/vintage.json';
import sakura from './definitions/sakura.json';
import royal from './definitions/royal.json';
import coastal from './definitions/coastal.json';
import serene from './definitions/serene.json';
import megan from './definitions/megan.json';
import heirloom from './definitions/heirloom.json';
import olivegrove from './definitions/olivegrove.json';
import ethereal from './definitions/ethereal.json';
import floral from './definitions/floral.json';
import sage from './definitions/sage.json';
import pink from './definitions/pink.json';
import peach from './definitions/peach.json';

export const TEMPLATES = {
  timeless,
  wellness,
  claire,
  heritage,
  reverie,
  garden,
  midnight,
  rustic,
  minimalist,
  tropical,
  vintage,
  sakura,
  royal,
  coastal,
  serene,
  megan,
  heirloom,
  olivegrove,
  ethereal,
  floral,
  sage,
  pink,
  peach,
};

export const getTemplate = (id) => TEMPLATES[id] || TEMPLATES.timeless;

export const getAllTemplates = () => Object.values(TEMPLATES);

export const getTemplateById = (id) => TEMPLATES[id];
